import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Jenis Ijin',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Jenis Ijin',
        href: '/adm/jenis-ijin',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_jenis_ijin',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'nama_ijin',
        label: 'Nama Ijin',
        sortable: true,
      },
      {
        key: 'type_ijin',
        label: 'Tipe',
        thStyle: {
          width: '150px',
        },
      },
      {
        key: 'aksi',
        label: 'Aksi',
        thStyle: {
          width: '150px',
        },
      },
    ],
    detail: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeJenisIjin(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchJenisIjin(context, params = null) {
    let result = await ApiGetRequest(`jenis-ijin`, params);
    return !result.error ? result.data.object : [];
  },

  async getListJenisIjin({ commit, state }) {
    commit('changeJenisIjin', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      id_pabrik: data.id_pabrik ? data.id_pabrik : '',
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`jenis-ijin`, params);
    commit('changeJenisIjin', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailJenisIjin({ commit }, payload = null) {
    commit('changeJenisIjin', {
      loading: true,
    });

    let result = await ApiGetRequest(`jenis-ijin/${payload.id}`);
    commit('changeJenisIjin', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadLogoJenisIjin({ commit, state }, payload) {
    commit('changeJenisIjin', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changeJenisIjin', {
      loading: false,
    });

    if (!result.error) {
      commit('changeJenisIjin', {
        form: {
          ...data.form,
          logo: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeJenisIjin', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`jenis-ijin/import`, {
      items: data.import_form || [],
    });

    commit('changeJenisIjin', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createJenisIjin({ commit, state, dispatch }) {
    commit('changeJenisIjin', {
      loading: true,
    });

    let result = await ApiPostRequest(`jenis-ijin`, state.data.form);
    commit('changeJenisIjin', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateJenisIjin({ commit, state, dispatch }, payload = null) {
    commit('changeJenisIjin', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `jenis-ijin/${payload.id}`,
      state.data.form,
    );

    commit('changeJenisIjin', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteJenisIjin({ commit, dispatch }, payload = null) {
    commit('changeJenisIjin', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`jenis-ijin/${payload.id}`);
    commit('changeJenisIjin', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
